<template>
  <div v-if="!item.hidden && hasMenuPermission(item) && funcHandle(item)">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)">
          <item
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="onlyOneChild.meta.title"
            :highlight="searchText"
          />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      popper-append-to-body
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="item.meta.title"
          :highlight="searchText"
        />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        :search-text="searchText"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
  import { isExternal } from '@/utils/validate';
  import { hasMenuPermission, getPlateForm, ROLES_ADMIN } from '@/utils/auth';
  import { resolvePath } from '@/utils/path-helper';
  import Item from './Item';
  import AppLink from './Link';
  import FixiOSBug from './FixiOSBug';

  export default {
    name: 'SidebarItem',
    components: { Item, AppLink },
    mixins: [FixiOSBug],
    props: {
      // route object
      item: {
        type: Object,
        required: true
      },
      isNest: {
        type: Boolean,
        default: false
      },
      basePath: {
        type: String,
        default: ''
      },
      searchText: {
        type: String,
        default() {
          return '';
        }
      }
    },
    data() {
      // To fix https://github.com/PanJiaChen/vueadmin--template/issues/237
      // TODO: refactor with render function
      this.onlyOneChild = null;
      return {};
    },
    methods: {
      hasMenuPermission,
      funcHandle(item) {
        if (getPlateForm() === ROLES_ADMIN) {
          // 大后台管理员
          return true;
        } else {
          // 后端接口获取已勾选的菜单权限code 半选+勾选的底层节点并去重

          const menuIdRightList = this.$store.state.app.permissionCodes;
          if (item.meta?.menuId) {
            return menuIdRightList.includes(item.meta.menuId);
          }
          //没有menuId的路由 默认展示
          return true;
        }
      },

      hasOneShowingChild(children = [], parent) {
        const showingChildren = children.filter((item) => {
          if (item.hidden) {
            return false;
          } else {
            // Temp set(will be used if only has one showing child)
            this.onlyOneChild = item;
            return true;
          }
        });

        // When there is only one child router, the child router is displayed by default
        // 添加父级菜单name判断，区分只包含一个子菜单时，是否展示层级结构
        if (showingChildren.length === 1 && !parent.name) {
          return true;
        }

        // Show parent if there are no child router to display
        if (showingChildren.length === 0) {
          this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
          return true;
        }

        return false;
      },
      resolvePath(routePath) {
        if (isExternal(routePath)) {
          return routePath;
        }
        if (isExternal(this.basePath)) {
          return this.basePath;
        }
        return resolvePath(this.basePath, routePath);
      }
    }
  };
</script>
